import { Alert, AlertDescription, AlertIcon, AlertTitle, Button, Flex, FormControl, Grid, Input, Spinner, Text, useToast } from '@chakra-ui/react'
import Card from 'components/Card/Card'
import CardBody from 'components/Card/CardBody'
import CardHeader from 'components/Card/CardHeader'
import React, { useState } from 'react'
import Field from './FormField'
import sanitizeForm, { sanitizeField } from 'functions/sanitizeForm'
import dateFormat, { stringToDate } from 'functions/dateFormat'
import { useSubmitRegisterForm } from 'hooks/useAutoRegister'
import { onError } from '@apollo/client/link/error'
import { addDays } from 'date-fns'
import bcrypt from "bcryptjs";


interface FormField {
    key: string,
    label: string,
}

interface FormData {
    key: string,
    value: string
}

const fields: FormField[] = [
    {
        key: "name",
        label: "Nome"
    },
    {
        key: "cpf",
        label: "CPF"
    },
    {
        key: "register",
        label: "Número da Carteirinha"
    },
    {
        key: "birthdate",
        label: "Data de Nascimento"
    },
    {
        key: "phone",
        label: "Telefone Celular"
    }
]

const setupSubmitFields = (formData: any): any[] => {
    const submitFields = [];

    for (const [key, value] of Object.entries(formData)) {
        submitFields.push({
            key: key,
            value: value,
        })
    }

    return submitFields;
}

const AutoRegister = () => {
    const [finished, setFinished] = useState<boolean>(false)

    const toast = useToast()
    const [submitForm, { loading: loadingSubmit }] = useSubmitRegisterForm({
        onSuccess: (data: any) => {
            setFinished(true);
        },
        onError: () => {
            toast({
                id: "messageSent",
                title: `Ocorreu um erro ao cadastrar`,
                duration: 4000,
                position: "bottom",
                status: "error"
            })
        }
    });

    const [data, setData] = useState({});

    const onSubmit = () => {
        const submitFields = setupSubmitFields(data);

        submitFields.forEach((field: FormData) => {
            if(["cpf", "phone", "register"].includes(field.key)) 
                field.value = sanitizeField(field.value)
            if (field.key == 'birthdate' || field.key == 'birth_date')
                try {
                    field.value = stringToDate(field.value).toISOString()
                } catch (e) {

                }
        })

        const variables = {
            input: {
                answers: JSON.stringify(submitFields)
            }
        }

        submitForm({ variables },);
    }

    return (
        <Flex w="full" minH="100vh" justifyContent="center" alignItems="center">
            <Card maxW="420px" minH="460px">
                {
                    !finished &&
                        <CardHeader minH="80px" justifyContent="center" alignItems="center">
                            Cadastro
                        </CardHeader>
                }
                <CardBody mt="auto" mb="auto">
                    <Flex flexDirection="column" w="full">
                        {
                            finished ?
                                <Flex w="full" justifyContent="center" alignItems="center">
                                    <Alert
                                        status='success'
                                        variant='subtle'
                                        flexDirection='column'
                                        alignItems='center'
                                        justifyContent='center'
                                        textAlign='center'
                                        height='200px'
                                    >
                                        <AlertIcon boxSize='40px' mr={0} />
                                        <AlertTitle mt={4} mb={1} fontSize='lg'>
                                            Cadastro realizado com sucesso!
                                        </AlertTitle>
                                    </Alert>
                                </Flex>
                                :
                                <>
                                    <Grid
                                        w="full"
                                        templateColumns="repeat(1, 1fr)"
                                        templateRows="repeat(2, 1fr)"
                                        gap="16px"
                                        mb="8"
                                    >
                                        {
                                            fields.map(field => <Field field={field} data={data} setData={setData} />)
                                        }
                                    </Grid>
                                    <Flex w="full" mb="2">
                                        <Button
                                            isLoading={loadingSubmit}
                                            disabled={loadingSubmit}
                                            w="full"
                                            colorScheme="green"
                                            onClick={onSubmit}
                                        >Cadastrar</Button>
                                    </Flex>
                                </>
                        }
                    </Flex>
                </CardBody>
            </Card>
        </Flex>
    )
}

export default AutoRegister